<template><span :class="['badge', `badge-${variant}`, pill && 'badge-pill']"><slot /></span></template>
<script>
export default {
    name: "SbBadge",
    props: {
        variant: { type: String, default: "secondary" },
        pill: { type: Boolean, default: false },
    },
};
</script>
